import React from "react";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import secondStep from "../../assets/img/shini.jpg";
import orthodontics2 from "../../assets/img/orthodontics2.jpg";
import ContactForm from "../../sections/ContactForm";
import Doctor from "../../sections/Doctor";
import firstStep from "../../assets/img/pop-bg.jpg";

export default function CompleteDiagnosis() {
  return (
    <>
      <div className="bg-orthodontics w-full h-[70vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl w-10/12 text-white text-center font-extrabold">
          Пълен ортодонтски анализ
        </h1>
      </div>
      <div className="page__width my-32 gap-2 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Пълен ортодонтски анализ
        </h2>
        <p className="text-body text-lg text-center">
          Целта на анализа е да се изготви точна диагноза и пълен план на
          лечение, за които са необходими фото снимки на лицето и зъбите,
          отпечатъци / сканиране на зъбите за изготвяне на ортодонтски модели и
          рентгенови изследвания- панорамна снимка, телерентгенография, както и
          други рентгенови изследвания (в случай, че са необходими)
          <p className="text-sm mt-4">
            <i>
              *Пълният ортодонтски анализ се извършва в рамките на две
              посещения.
            </i>
          </p>
        </p>
      </div>
      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={firstStep} className="w-full aspect-square rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">Първа стъпка</h2>
          <p className="text-base mt-4 text-body font-normal">
            Въз основа на прецизните фото и рентгенови снимки, диагностични
            модели и компютърния анализ на телерентгенография, се изготвя
            индивидуална диагноза и лечебен план. Това е най-важната стъпка в
            ортодонтското лечение.
          </p>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={secondStep} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Вторo посещение
          </h2>
          <p className="text-base mt-4 text-body font-normal">
            По време на второто посещение се разясняват подробностите, свързани
            с ортодонтското лечение-точна диагноза и план на лечение,
            продължителност на лечението, важността на съдействието на
            пациента;конкретна стойност на лечението и финансови схеми на
            плащане.
          </p>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <Doctor name="daliya" />

      {/* <div className="page__width mt-20 flex flex-col justify-between lg:flex-row-reverse items-center gap-8">
                <div className="w-full lg:w-2/5">
                    <ImageWrapper
                        src={testimonial}
                        className="w-full rounded-full"
                    />
                </div>
                <div className="w-full lg:w-1/2 flex gap-2 flex-col items-start">
                    <div className="flex items-center gap-1">
                        <div className="bg-brand w-16 rounded-full h-[6px]"></div>
                        <div className="bg-brand w-8 rounded-full h-[6px]"></div>
                        <div className="bg-brand w-2 rounded-full h-[6px]"></div>
                    </div>
                    <h2 className="text-xl font-extrabold text-heading">Име</h2>
                    <p className="text-xl text-body font-normal">
                        Богдан Бъчваров
                    </p>
                     <h2 className="text-xl font-extrabold text-heading">
                        Случай
                    </h2>
                    <p className="text-xl text-body font-normal">
                        Изпопадали зъби, дъх с мирис на 6-годишно застояло се
                        кисело мляко "Верея" с 2% масленост.
                    </p> 
                    <h2 className="text-xl font-extrabold text-heading">
                        Коментар
                    </h2>
                    <p className="text-xl text-body font-normal">
                        Не ме бива много в изказванията, но Ви благодаря от
                        цялото си сърце за всичко, което направихте за мен по
                        време и след лечението ми, по пътя към моята СУПЕР
                        усмивка. Вие ми дадохте един нов шанс, едно ново начало,
                        изпълнено с много красиви усмивки. Не съм срещал и едва
                        ли ще срещна по-добри и отдадени на работата си хора, и
                        най-вече истински професионалисти. Желая Ви все така да
                        подарявате на хората нещото, което ги краси най-много –
                        УСМИВКАТА. С много обич и благодарност…
                    </p>
                    <Button
                        type="cta-border"
                        href="#">
                        Запазете час още сега!
                    </Button>
                </div>
            </div> */}

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic@gmail.com
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
      <div className="page__width flex flex-col items-center gap-4">
        <h2 className="text-3xl font-extrabold text-heading">Други услуги</h2>
        <div className="flex flex-col lg:flex-row items-start justify-center gap-4 w-full">
          <div className="w-full lg:w-[30%] flex flex-col items-start gap-2 rounded-md p-8">
            <a
              href="/services/orthodontics"
              className="w-full group overflow-hidden rounded-[inherit]"
            >
              <ImageWrapper
                src={orthodontics2}
                className="w-full group-hover:scale-110 group-hover:opacity-80 rounded-[inherit] transition-all duration-200"
              />
            </a>
            <h3 className="text-2xl font-bold text-heading">
              Първичен ортодонтски преглед
            </h3>
            <p className="text-base text-body font-normal">
              Ортодонтското лечение е целенасочен процес за корекция и
              подреждане на зъбите, който не само подобрява естетиката на
              усмивката, но и значително оптимизира функцията на зъбите.{" "}
            </p>
            <a
              href="/services/orthodontics"
              className="text-brand navlink relative text-lg font-bold"
            >
              Виж повече
            </a>
          </div>
          <div className="w-full lg:w-[30%] flex flex-col items-start gap-2 rounded-md p-8">
            <a
              href="/services/orthodontics"
              className="w-full group overflow-hidden rounded-[inherit]"
            >
              <ImageWrapper
                src={orthodontics2}
                className="w-full group-hover:scale-110 group-hover:opacity-80 rounded-[inherit] transition-all duration-200"
              />
            </a>
            <h3 className="text-2xl font-bold text-heading">
              Ортодонтия за деца 2-6г.
            </h3>
            <p className="text-base text-body font-normal">
              Ортодонтското лечение е целенасочен процес за корекция и
              подреждане на зъбите, който не само подобрява естетиката на
              усмивката, но и значително оптимизира функцията на зъбите.{" "}
            </p>
            <a
              href="/services/orthodontics"
              className="text-brand navlink relative text-lg font-bold"
            >
              Виж повече
            </a>
          </div>
          <div className="w-full lg:w-[30%] flex flex-col items-start gap-2 rounded-md p-8">
            <a
              href="/services/orthodontics"
              className="w-full group overflow-hidden rounded-[inherit]"
            >
              <ImageWrapper
                src={orthodontics2}
                className="w-full group-hover:scale-110 group-hover:opacity-80 rounded-[inherit] transition-all duration-200"
              />
            </a>
            <h3 className="text-2xl font-bold text-heading">
              Ортодонтия за възрастни
            </h3>
            <p className="text-base text-body font-normal">
              Ортодонтското лечение е целенасочен процес за корекция и
              подреждане на зъбите, който не само подобрява естетиката на
              усмивката, но и значително оптимизира функцията на зъбите.{" "}
            </p>
            <a
              href="/services/orthodontics"
              className="navlink relative text-brand font-bold text-lg"
            >
              Виж повече
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
